import { Component, Injector, OnInit } from '@angular/core';
import { AuthorRuleService } from 'tnx-admin-service/authorization/author-rule/services';
import { Property, RoleType, RuleOperator, RuleType } from 'tnx-admin-service/authorization/constants';
import { RoleService } from 'tnx-admin-service/authorization/role/services';
import { UserGroupService } from 'tnx-admin-service/authorization/usergroup/services';
import { ComponentContextService, CustomControlSchema, DataFormBase, DropdownControlSchema, EntityPickerColumn, EntityPickerControlSchema, EventData, Filter, FormSchemaBase, Operator, OrganizationService, PositionService, TextAreaControlSchema, TextControlSchema, UserPickerControlSchema } from 'tnx-shared';

@Component({
    selector: 'app-author-rule-form',
    templateUrl: './author-rule-form.component.html',
    styleUrls: ['./author-rule-form.component.scss'],
    providers: [ComponentContextService]
})
export class AuthorRuleFormComponent extends DataFormBase implements OnInit {


    type = [
        { label: 'Thông tin tài khoản', value: RuleType.Property },
        { label: 'Toàn bộ tài khoản', value: RuleType.All }
    ]

    properties = [
        { label: 'Loại tài khoản', value: Property.AccountType },
        { label: 'Chức vụ', value: Property.Position },
        { label: 'Phòng ban', value: Property.Organization },
    ]

    operators = [
        { label: 'Là', value: RuleOperator.Equal },
        { label: 'Không là', value: RuleOperator.NotEqual }
    ]

    loaiTaiKhoans = [
        { label: 'Cán bộ', value: '2' },
        { label: 'Sinh viên', value: '1' }
    ]

    chucVus: any;
    coCauToChucs: any;
    organizationControl: any;
    property = Property;
    sourceOrganization = [];


    constructor(
        protected _injector: Injector,
        private _authorRuleService: AuthorRuleService,
        private _roleService: RoleService,
        private _organizationService: OrganizationService,
        private _positionService: PositionService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.getOrganizationSource();

        this.setting.baseService = this._authorRuleService;
        this.organizationControl = new DropdownControlSchema({
            isTree: true,
            fieldTree: 'idCha',
            valueParentRoot: -1,
            displayField: 'label',
            valueField: 'value'
        });

        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'name',
                label: 'Tên',
                required: true,
                mdWidth: 12
            }),
            new EntityPickerControlSchema({
                mdWidth: 12,
                field: 'idRoles',
                title: 'Chọn vai trò',
                label: 'Vai trò',
                displayField: 'name',
                baseService: this._roleService,
                defaultFilters: () => {
                    const filters = <Filter[]>[];

                    filters.push({ field: 'type', operator: Operator.equal, value: RoleType.Group.toString() });

                    return filters;
                },
                columns: [
                    new EntityPickerColumn({
                        code: 'code',
                        label: 'Mã vai trò',
                        operator: Operator.contain,
                    }),
                    new EntityPickerColumn({
                        code: 'name',
                        label: 'Tên vai trò',
                        operator: Operator.contain,
                    })
                ]
            }),
            new CustomControlSchema({
                field: 'rules',
                mdWidth: 12
            }),
            new TextAreaControlSchema({
                field: 'description',
                label: 'Mô tả',
                mdWidth: 12
            }),
        ];
    }

    async getOrganizationSource() {
        var rs = await this._organizationService.getAll();
        this.sourceOrganization.push(...rs.data.map(x => <any>{ label: x.ten, value: x.id }));
    }

    async onFormInitialized(formEvent: EventData) {
        if (this.model.data.id) {
        }
        else {

        }
    }

    async onFormEvent(evt) {
        // các event trong form
        console.log(evt);
    }

    async modifyDetailData(data) {
        if (data.ruleDetails.length > 0) {
            await data.ruleDetails.forEach(
                async (ruleDetail) => {
                    if (ruleDetail.property == Property.Organization) {
                        ruleDetail.value = parseInt(ruleDetail.value);
                    }

                    await this.onChangeProperty(ruleDetail, true);
                })
        }
        data.idRoles = data.ruleHasRoles.map(x => x.idRole);
    }

    // async onAfterGetDetail() {
    //     // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    // }

    onBeforeSave() {
        // trước khi lưu
    }

    deleteRule(rule) {
        this.model.data.ruleDetails = this.model.data.ruleDetails.filter(x => x != rule);
    }

    addRule() {
        if (!this.model.data.ruleDetails) {
            this.model.data.ruleDetails = [];
        }
        this.model.data.ruleDetails.push({
            values: this.loaiTaiKhoans,
            operator: RuleOperator.Equal,
            value: this.loaiTaiKhoans[0].value,
            property: Property.AccountType
        })
    }

    async onChangeProperty(rowData, firstLoad?) {
        rowData.values = [];
        switch (rowData.property) {
            case Property.AccountType:
                rowData.values = this.loaiTaiKhoans;
                break;
            case Property.Position:
                await this.getChucVuData();
                rowData.values = this.chucVus;
                break;
            case Property.Organization:
                // await this.getCoCauToChuc();
                rowData.values = this.sourceOrganization;
                break;
            default:
                break;
        }

        if (!firstLoad && rowData.values.length > 0) {
            rowData.value = rowData.values[0].value;
        }
    }

    async getChucVuData() {
        if (this.chucVus) {
            return;
        }

        var rs = await this._positionService.getAll();
        this.chucVus = rs.data.map(x => <any>{ label: x.ten, value: x.code });
    }

}
